import { getPlanMonthList } from '@/core/utils/getPlanMonthList.ts'
import { useSelector } from 'react-redux'
import {
  selectIsLoadingPlan,
  selectIsSearchingProducts,
} from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'

const DISPLAY_MONTHS_COUNT = 24

const usePlanTableConfig = () => {
  const isSearchingProducts = useSelector(selectIsSearchingProducts)

  const isLoadingPlan = useSelector(selectIsLoadingPlan)

  const isTableLoading = isSearchingProducts || isLoadingPlan

  const { dates, formatted } = getPlanMonthList(DISPLAY_MONTHS_COUNT)

  return { dates, formatted, isTableLoading }
}

export { usePlanTableConfig }
